export default __webpack_public_path__ + "static/media/facebook.df874090.svg";